import React from "react"
import I18n from "@helper/i18nInstance"
import onEnterOrSpace from "@helper/onEnterOrSpace"

import { useQuiz } from "@Quiz/context"

const MiniQuestionHeader: React.FC<{showQuestionAgain(): void}> = ({showQuestionAgain}) => {
  const { quiz } = useQuiz()
  if (!quiz?.question) { return null }

  const className = [
    "neo__miniQuestionQuestion",
    quiz.question.image ? "neo__miniQuestionQuestion--withImage" : "neo__miniQuestionQuestion--withoutImage"
  ].join(" ")

  return (
    <div className={className}>
      <a
        className="neo__miniQuestionQuestion__backLink"
        role="button"
        tabIndex={0}
        aria-label={I18n.t("quiz.question.aria_show_question_again")}
        onClick={showQuestionAgain}
        onKeyDown={onEnterOrSpace(showQuestionAgain)} />
      {quiz.question.image && <img onClick={showQuestionAgain} className="neo__miniQuestionQuestion__img" src={quiz.question.image["1x"]} />}
      <div className="neo__miniQuestionQuestion__text">
        <div dangerouslySetInnerHTML={{__html: quiz.question.text}} />
      </div>
    </div>
  )
}

export default MiniQuestionHeader
